import createReactComponent from '../createReactComponent';
var BatteryCharging = createReactComponent('BatteryCharging', [['path', {
  d: 'M7 7H3.78A1.73 1.73 0 002 8.67v6.66A1.73 1.73 0 003.78 17H6m8-10h2.22A1.73 1.73 0 0118 8.67v6.66A1.73 1.73 0 0116.22 17H13',
  key: 'kxb35g'
}], ['polyline', {
  points: '11 7 8 12 12 12 9 17',
  key: 'w083az'
}], ['line', {
  x1: '22',
  x2: '22',
  y1: '11',
  y2: '13',
  key: '4dh1rd'
}]]);
export default BatteryCharging;